import LightningOut from '@groove/lightning.out/LightningOut';
import StandardRenderer from '@groove/lightning.out/Renderer/StandardRenderer';

const lightningOut = new LightningOut(new StandardRenderer());

export default lightningOut;
